module.exports = __webpack_public_path__ + "img/premiumCountdown.ce61edac.png";